import * as React from "react";
import type { SVGProps } from "react";
const SvgIconLocation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3.82C9.02.99 6.94 1.92 5.32 3.5c-.57.55-.97 1.04-1.37 1.66Q2.75 7.01 2.46 9.2c-.07.59-.09 1.64-.02 2.12.16 1.3.47 2.26 1.09 3.52.55 1.13 1.35 2.32 2.3 3.44 1.15 1.35 2.66 2.78 4.15 3.94 1.12.87 1.34.97 2.02.97.28 0 .38 0 .54-.05.36-.1.5-.18 1.18-.7 1.63-1.22 3.31-2.8 4.55-4.28 1.44-1.73 2.48-3.56 2.97-5.25.3-1 .4-1.93.36-2.95-.04-.79-.14-1.41-.35-2.17-.73-2.62-2.6-4.85-5.07-6.04-1.5-.72-3.24-1.06-4.88-.93m-.08 1.73c-1.25.12-2.53.57-3.59 1.28-.45.3-.78.58-1.21 1-.68.68-1.1 1.26-1.5 2.1-.53 1.07-.77 2.06-.8 3.26-.02.5 0 .83.08 1.34.25 1.5 1.02 3.13 2.26 4.78 1.23 1.64 3.05 3.41 4.98 4.87.37.27.42.3.56.3s.19-.03.56-.3c1.92-1.45 3.76-3.24 4.98-4.87q1.37-1.82 1.96-3.57c.43-1.3.5-2.56.24-3.9-.21-1.05-.69-2.15-1.3-3-.38-.54-1.01-1.2-1.5-1.6-1.21-.96-2.68-1.55-4.2-1.7-.32-.02-1.2-.02-1.52 0m.48 3.03c-.58.06-1 .18-1.47.4C9.03 6.57 8.2 7.7 8 9.02c-.04.31-.04.87 0 1.18.27 1.77 1.63 3.13 3.41 3.41.25.04.93.04 1.18 0 1.62-.25 2.92-1.43 3.32-3 .09-.33.12-.62.12-1 0-.79-.19-1.47-.61-2.14-.61-.99-1.66-1.68-2.81-1.85-.2-.03-.76-.05-.91-.04m-.06 1.73c-.76.15-1.37.59-1.7 1.22-.68 1.32 0 2.88 1.43 3.32.2.06.24.06.63.06s.44 0 .63-.06c.9-.28 1.52-.97 1.66-1.88.05-.27.05-.45 0-.72-.14-.9-.77-1.6-1.66-1.87-.18-.06-.26-.07-.57-.07z"
      fill="#475569"
    />
  </svg>
);
export default SvgIconLocation;
